import { PageUid, AttributeKey } from "../context/CustomisationContext";

export type PageStyle = {
  backgroundColor?: string;
  titleColor?: string;
  textColor?: string;
  secondaryTextColor?: string;
};

const secondaryTextKeyByPage: Record<PageUid, AttributeKey> = {
  GPC: "gpcSecondaryTextColor",
  LOGIN: "loginSecondaryTextColor",
  HOME: "homeSecondaryTextColor",
  CERTIFICATES: "certificatesSecondaryTextColor",
  PROFILE: "profileSecondaryTextColor",
};

const primaryBgKeyByPage: Record<PageUid, AttributeKey> = {
  GPC: "gpcPrimaryBgColor",
  LOGIN: "loginPrimaryBgColor",
  HOME: "homePrimaryBgColor",
  CERTIFICATES: "certificatesPrimaryBgColor",
  PROFILE: "profilePrimaryBgColor",
};

const primaryTextKeyByPage: Record<PageUid, AttributeKey> = {
  GPC: "gpcPrimaryTextColor",
  LOGIN: "loginPrimaryTextColor",
  HOME: "homePrimaryTextColor",
  CERTIFICATES: "certificatesPrimaryTextColor",
  PROFILE: "profilePrimaryTextColor",
};

export const resolvePageStyle = (
  pageUid: PageUid,
  getValue: (
    p: PageUid,
    s: "backgroundSettings" | "textColorsSettings",
    a: AttributeKey
  ) => string
): PageStyle => {
  const backgroundColor =
    getValue(pageUid, "backgroundSettings", primaryBgKeyByPage[pageUid]) ||
    getValue("GPC", "backgroundSettings", "gpcPrimaryBgColor");

  const titleColor =
    getValue(pageUid, "textColorsSettings", primaryTextKeyByPage[pageUid]) ||
    getValue("GPC", "textColorsSettings", "gpcPrimaryTextColor");

  const secondaryTextColor =
    getValue(pageUid, "textColorsSettings", secondaryTextKeyByPage[pageUid]) ||
    getValue("GPC", "textColorsSettings", "gpcSecondaryTextColor");

  return {
    backgroundColor: backgroundColor || undefined,
    titleColor: titleColor || undefined,
    textColor: titleColor || undefined,
    secondaryTextColor: secondaryTextColor || undefined,
  };
};
